import { useTranslation } from "shared/contexts/I18nContext";
import { FaInfoCircle } from "react-icons/fa";
import { useState } from "react";

const FeatureLimitDisplay = ({ feature, currentCount, limit }) => {
    const { t } = useTranslation();
    const [isTooltipVisible, setTooltipVisible] = useState(false);

    const isLimitReached = limit !== Infinity && currentCount >= limit;

    const textColorClass = isLimitReached
        ? "text-red-500 dark:text-red-400"
        : "text-gray-600 dark:text-gray-400";

    const iconColorClass = isLimitReached
        ? "text-red-500 dark:text-red-400"
        : "text-green-600 dark:text-green-400";

    return (
        <div className={`relative flex items-center text-sm font-medium ${textColorClass}`}>


            <div
                className={`ml-2 relative flex items-center ${iconColorClass}`}
                onMouseEnter={() => setTooltipVisible(true)}
                onMouseLeave={() => setTooltipVisible(false)}
            >
                {/* Tooltip to the left */}
                <div
                    className={`absolute right-full top-1/2 -translate-y-1/2 mr-2 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 text-xs px-3 py-1 rounded shadow transition-opacity duration-200 whitespace-nowrap ${isTooltipVisible ? "opacity-100 visible" : "opacity-0 invisible"
                        }`}
                >
                    <span>
                        {t("currentUsage")}: {currentCount} / {limit === Infinity ? "∞" : limit} {t(`${feature}Limit`)}
                    </span>                </div>

                <FaInfoCircle className="w-6 h-6" />
            </div>
        </div>
    );
};

export default FeatureLimitDisplay;
